import 'react-app-polyfill/ie9';
import * as React from 'react';
import { Provider } from "react-redux";
import Routes from "./Routes/Routes";
import { ConnectedRouter } from "connected-react-router";
import store, { history, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import axios from "axios";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import ReduxToastr from 'react-redux-toastr';
import ErrorBoundary from './components/AdvancedComponents/ErrorBoundary';
import { enableDarkTheme, enableLightTheme } from './redux/actions/themeActions';
import { UpdateCompanyData } from './redux/actions/CompanyDataAction';
import Helmet from 'react-helmet';
import { GetCompanyDataResult } from './Interfaces/Interfaces';
import Lazy from './components/Lazy';
import { Logout } from './redux/actions/AuthActions';
import { push } from "connected-react-router";
import { ClearPushNotifications } from './redux/actions/PushNotificationActions';
import { CheckSignalR } from './redux/actions/SignalRAction';
import { Col, Label } from "reactstrap";
import { HandleUserConnectivity } from './redux/actions/UserConnectivityAction';
import { CheckIfIsExternalPage, DisplayZendDeskChat } from './Helpers/DataHelpers';


export function toDataUrl(url: any, callback: any) {
    var xhr: any = new XMLHttpRequest();
    xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}
export interface AppProps {
}
declare var require: any
const iconDefault = require("./Assets/imgs/favicon.ico") as string;
const session = require("./Assets/imgs/session.png") as string;
export interface AppState {
    icon: string;
    GetURL: string;
    titleName: string;
    GetCompanyDataResult: GetCompanyDataResult;
    companyCode: any;
    openOfflinePopup: boolean;
    isopenUserActivity: boolean;
    timeoutID: any;
}


class App extends React.Component<AppProps, AppState> {
    state = {
        titleName: '',
        GetCompanyDataResult: new GetCompanyDataResult(),
        icon: '',
        GetURL: "",
        companyCode: "",
        openOfflinePopup: false,
        isopenUserActivity: false,
        timeoutID: null as any,
    }
    componentDidMount() {
        toDataUrl("https://cdn-yoonit.azureedge.net/cdn/imgs/connection.png", function (myBase64: any) {//TODO edit appsettings
            window.localStorage.setItem("connectionImg", myBase64);
        });
        axios.post<GetCompanyDataResult>("api/auth/GetCompanyData") //from company data as we dont know which client tell it arrives 
            .then(res => {
                store.dispatch(UpdateCompanyData(res.data ? res.data : new GetCompanyDataResult()));//must remove  or check 
                this.setState({ titleName: res.data.HeaderTitle });
                this.setState({
                    companyCode: res.data.CompanyCode,
                    GetURL: res.data.YoonitGetURL,
                });
                this.setState({ GetCompanyDataResult: res.data });
                if (store && store.getState() && store.getState().theme && store.getState().theme.currentTheme) {
                    if (store.getState().theme.currentTheme === 'addons-Dark')
                        store.dispatch(enableDarkTheme());
                    else if (store.getState().theme.currentTheme === 'addons-Light')
                        store.dispatch(enableLightTheme());
                    else {
                        if (res.data.DefaultTheme === 'dark')
                            store.dispatch(enableDarkTheme());
                        else
                            store.dispatch(enableLightTheme());
                    }
                }
                else {
                    if (res.data.DefaultTheme === 'dark')
                        store.dispatch(enableDarkTheme());
                    else
                        store.dispatch(enableLightTheme());
                }

            })
            .catch((e: any) => {
                console.error(e);
                store.dispatch(UpdateCompanyData(new GetCompanyDataResult()));
            });
        this.CheckActivityAndInternetStatus();
        this.LoadZendesk();

    }
    Logout = () => {
        DisplayZendDeskChat(false);
        store.dispatch(ClearPushNotifications({
            PushNotificationStatus: [],
            signalRIsConnected: false
        }));
        store.dispatch(Logout());
        store.dispatch(push('/'));
    }
    CheckToken = () => {
        axios.post<boolean>("api/auth/CheckToken", { Token: store.getState().auth.UserData.Token })
            .then(res => {
                if (res.data) {
                    store.dispatch(CheckSignalR()); //check if on will triggrer again
                }
                else {
                    DisplayZendDeskChat(false);
                    store.dispatch(Logout());
                    store.dispatch(push('/login'));
                }
            })
            .catch((e: any) => {
                DisplayZendDeskChat(false);
                store.dispatch(Logout());
                store.dispatch(push('/login'));
                console.error(e);
            });
    }
    openUserActivity = () => {
        this.setState({ isopenUserActivity: true })
        store.dispatch(HandleUserConnectivity(false));
    }
    closeUserActivity = () => {
        if (store && !store.getState().UserConnectivity) {
            this.CheckToken();
            store.dispatch(HandleUserConnectivity(true));//only trigger when false to set true
        }
        this.setState({ isopenUserActivity: false }); //online
    }
    openOfflinePopup = () => {
        //store.dispatch(push('/Offline'));//keep Code in page(just remove page) resource nto loaded if reditrect to new page
        this.setState({ openOfflinePopup: true, isopenUserActivity: false })//ffline os inactive is false as diffwrnt actions
        store.dispatch(HandleUserConnectivity(false));
    }
    closeOfflinePopup = () => {
        if (store && !store.getState().UserConnectivity) {
            this.CheckToken();
        }
        this.setState({ openOfflinePopup: false }); //online
        store.dispatch(HandleUserConnectivity(true));
        //store.dispatch(push('/'));
    }
    CheckActivityAndInternetStatus = () => {
        store.dispatch(CheckSignalR()); // reconnect if off    //may just need  in listeners
        window.addEventListener("online", this.closeOfflinePopup);
        window.addEventListener("offline", this.openOfflinePopup);
        //window.addEventListener("mouseout", () => console.log("Enttterrr"));
        this.checkUserActivity();
    }
    navigateToLogin = () => {
        store.dispatch(push('/login'));
    }
    checkUserActivity = () => {
        window.addEventListener("mousemove", this.resetTimer, false);
        window.addEventListener("mousedown", this.resetTimer, false);
        window.addEventListener("keypress", this.resetTimer, false);
        window.addEventListener("DOMMouseScroll", this.resetTimer, false);
        window.addEventListener("mousewheel", this.resetTimer, false);
        window.addEventListener("touchmove", this.resetTimer, false);
        window.addEventListener("MSPointerMove", this.resetTimer, false);

        this.startTimer();
    }

    startTimer = () => {
        // wait 7200000 millseconds ,2hrs before calling goInactive
        this.setState({ timeoutID: window.setTimeout(this.goInactive, 7200000) })
    }
    resetTimer = (e: any) => {
        window.clearTimeout(this.state.timeoutID);
        this.goActive();
    }
    goInactive = () => {
        if (!this.state.openOfflinePopup)
            this.openUserActivity();
    }

    goActive = () => {
        if (!this.state.openOfflinePopup)
            this.closeUserActivity();
        this.startTimer();
    }
    LoadZendesk = () => {
        let _self = this;
        let tag = document.createElement('script');
        tag.async = true;
        tag.id = "ze-snippet";
        tag.src = 'https://static.zdassets.com/ekr/snippet.js?key=84807906-e8ec-41e0-b7a0-ab70afeb4600';
        tag.onload = function () {
            let isAuth = store.getState() && store.getState().auth &&  store.getState().auth.isAuth;
            if (!isAuth || CheckIfIsExternalPage(window.location.href)) {
                DisplayZendDeskChat(false);
            } else {
                DisplayZendDeskChat(true);
            }
        };
        let head = document.getElementsByTagName('head')[0];
        //head.appendChild(tag);
        try {
            document.head.appendChild(tag);
        } catch (e) {
            console.error("ZendDesk", e);
        }
        //let body = document.getElementsByTagName('body')[0];
        //body.appendChild(tag);//loaded after load page //as in index.html wont work 
    }
    render() {
        let isAuth = store.getState() && store.getState().auth &&  store.getState().auth.isAuth;
        if (!isAuth || CheckIfIsExternalPage(window.location.href)) {
            DisplayZendDeskChat(false);
        } else {
            DisplayZendDeskChat(true);
        }
        return (
            <React.Suspense fallback={<Lazy />}>
                <ErrorBoundary>
                    <Provider store={store}>
                        <PersistGate loading={null} persistor={persistor}>
                            <ConnectedRouter history={history}>
                                <div hidden={this.state.openOfflinePopup || this.state.isopenUserActivity}>
                                    <Routes history={history} />
                                </div>
                                {this.state.openOfflinePopup &&
                                    <div>
                                        {this.RenderOfflienPopup()}
                                    </div>
                                }
                                {!this.state.openOfflinePopup && this.state.isopenUserActivity &&
                                    <div>
                                        {this.RenderUserActivityPopup()}
                                    </div>
                                }
                            </ConnectedRouter>
                        </PersistGate>
                        <Helmet>
                            <title>{this.ReturnTitle()}</title>
                            <link rel="icon" type="image/png" href={(this.state.icon === "" || this.state.icon === null) ? iconDefault : this.state.icon} sizes="16x16" />
                        </Helmet>
                        <ReduxToastr
                            timeOut={5000}
                            newestOnTop={true}
                            position="bottom-center"
                            transitionIn="fadeIn"
                            transitionOut="fadeOut"
                            progressBar
                            closeOnToastrClick
                            preventDuplicates
                        />
                    </Provider>
                </ErrorBoundary>
            </React.Suspense>
        );
    }
    RenderOfflienPopup = (): React.ReactNode => {
        let img: any = window.localStorage.getItem("connectionImg") ? window.localStorage.getItem("connectionImg") : 'not load';
        return <div className=" SessionPage "  >
            <Col sm="10" md="8" lg="8" className="mx-auto d-table h-100 ">
                <div className="d-table-cell align-middle ">

                    <div className="sessionBox text-center" >
                        <img src={img} alt="" className="mt-3" />
                        <div className="d-block mt-3 text-center m10">
                            <Label className="text-Grey font-32 t-bold d-block mb-2"> Connection Lost </Label>
                            <Label className="text-Grey font-24 d-block m-0"> Sorry we're having trouble reaching the server. </Label>
                            <Label className="text-Grey font-24 d-block m-0 mb-3"> Please check your connection and refresh the page. </Label>
                        </div>
                    </div>
                </div>
            </Col>
        </div>;
    }
    RenderUserActivityPopup = (): React.ReactNode => {
        return <div className=" SessionPage "  >
            <Col sm="10" md="8" lg="8" className="mx-auto d-table h-100 ">
                <div className="d-table-cell align-middle ">

                    <div className="sessionBox text-center p10" >
                        <img src={session} alt="" className="mt-3" />
                        <div className="d-block mt-3 text-center m10">
                            <Label className="text-Grey font-32 t-bold d-block mb-2"> Session Expired </Label>
                            <Label className="text-Grey font-24 d-block m-0"> Looks like your session has expired due to inactivity. </Label>
                        </div>
                    </div>
                </div>
            </Col>
        </div>;
    }

    ReturnTitle = (): any => {
        if (window.location.href.toLowerCase().includes('/documentation')) return `Documentation - Support Center`;
        if (window.location.href.toLowerCase().includes('/subscriptions')) return `Subscriptions - Support Center`;
        if (window.location.href.toLowerCase().includes('/servicedesk')) return `Service Desk - Support Center`;
        return this.state.titleName;
    }
}

export default App;
